import { api } from '@/lib/api/client'

/** Why a row needs attention. Each maps to a rule in organization.md. */
export type AccessFinding =
  | 'no_expiry'
  | 'lapsed'
  | 'no_client'
  | 'archived_project'
  | 'inactive_person'

export interface AccessReviewRow {
  id: string
  guest: { id: string; name: string; email: string; isActive: boolean } | null
  client: { id: string; name: string } | null
  project: { key: string; name: string; archived: boolean } | null
  invitedBy: string | null
  grantedOn: string | null
  expiresAt: string | null
  /** Whole days, negative once lapsed. Null when there is no expiry at all. */
  daysRemaining: number | null
  findings: AccessFinding[]
}

export interface AccessReview {
  rows: AccessReviewRow[]
  total: number
  needAttention: number
}

export async function fetchAccessReview(): Promise<AccessReview> {
  const { data } = await api.get<{
    data: AccessReviewRow[]
    meta: { total: number; needAttention: number }
  }>('/access-review')

  return { rows: data.data, total: data.meta.total, needAttention: data.meta.needAttention }
}

/** Taking a key back. The review is only worth opening if it can be acted on. */
export async function revokeMembership(id: string): Promise<void> {
  await api.delete(`/memberships/${id}`)
}
